<template>
    <layout>
        <template slot="title">
            <img width="200" src="/logo.png" alt="Teco Milano" title="Teco Milano" />
        </template>
        <slot></slot>
        <template slot="footer">
            {{trans('layout.footer')}}
        </template>
    </layout>
</template>
<script>
import AppLayout from "./layout/AppLayout";
import SelectLocale from "./SelectLocale";

export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    components:{
        SelectLocale,
        layout:AppLayout,
    }
}
</script>
